export default {
  template: '#selected_products_list',
  props: ['product'],
  events: {
    'user-initialized': function() {
      this.parseSellingPrice(null, true);
    },
  },
  data: function() {
    return {
      imagePath: this.$root.getDesignerHelper().imagePath,
      dtgEnabled: true,
      screenColumn: 'col-md-6',
      productColors: [],
      hoverColor: undefined,
      lastSelectedColor: undefined
    };
  },
  computed: {
    profit: function() {
      return (parseFloat(this.product.selling_price) - parseFloat(this.product.base_price)).toFixed(2);
    },
    dtgPrice: function() {
      var product = this.product.product.products;
      return this.$root.getPricingByProduct(product, 1);
    },
    dtgProfit: function() {
      return parseFloat(this.product.selling_price) - parseFloat(this.dtgPrice);
    },
    sortedColors: function() {
      return this.$root.getDesignerHelper().sortColors(this.productColors);
    },
    suggestedPriceToShow() {
      var product = this.product.product.products;
      return product.suggested_price;
    },
    campaignGoal() {
      return this.$root.campaignData.goal;
    },
  },
  created: function() {
    var that = this;
    this.$on('pricing-recalculated', function() {
      that.reCalculatePricing();
    });

    this.$on('on-dtg-enabled', function(state) {
      this.dtgEnabled = state;
    });
  },
  ready: function() {
    this.$set('productColors', this.product.product.products.product_colors);

    if (this.product.product.products.product_type === "CANVAS") {
      let self = this;
      this.productColors.forEach(function(color) {
        self.activateColor(color);
      });
    }
  },
  watch: {
    'product.selling_price': function(newVal, val) {
      this.$parent.updateAdditionalProductPricing(this.product.product.products.id, newVal, parseFloat(this.profit).toFixed(2));
    }
  },
  methods: {
    activateColor: function(color) {
      var that = this,
        globalAdditionalProductSelections = this.$root.campaignData.additionalProducts, //Getting all the Global additional products
        productExists = _.findIndex(globalAdditionalProductSelections, function(p) {
          return (p.product == that.product.product.products.id && p.color == color.id);
        }), //Checking if the product exists that is being called.
        productToBeRemoved = globalAdditionalProductSelections[productExists];

      //Calling the method on the parent to perform the same action.
      this.$parent.activateColor(color, this.product.product.products.id, this.product.selling_price, this.profit, this.product.base_price, this.product.dtg_price);

      if (productExists == -1) {
        this.lastSelectedColor = color.hex;
      } else {
        if (productToBeRemoved.hex == color.hex) {
          var firstSelectedColor = _.find(globalAdditionalProductSelections, function(p) {
            return p.product == that.product.product.products.id;
          });
          if (firstSelectedColor) {
            this.lastSelectedColor = firstSelectedColor.hex;
          } else {
            this.lastSelectedColor = undefined;
          }

        }
      }
    },
    isColorActive: function(color) {
      return this.$parent.isColorActive(color, this.product.product.products.id);
    },
    removeItem: function(product) {
      this.$parent.removeItem(product);
    },
    reCalculatePricing: function() {
      var basePrice = parseFloat(this.product.base_price),
        sellingPrice = parseFloat(this.product.selling_price),
        profit = sellingPrice - basePrice;

      var new_base_price = this.$parent.getPricingByProduct(this.product.product.products, this.campaignGoal);
      this.product.base_price = parseFloat(new_base_price).toFixed(2);
      // this.product.selling_price = (parseFloat(new_base_price) + profit).toFixed(2);
      this.product.profit = profit.toFixed(2);
    },
    parseSellingPrice: function(e, skipNotification) {
      var sellingPrice = parseFloat(this.product.selling_price),
        dtgPrice = this.$parent.getPricingByProduct(this.product.product.products, 1),
          maxSellingPrice = 0;

      if(this.isDoubleSided()) {
        maxSellingPrice = parseFloat(this.product.product.products.max_selling_price_double_sided);
      } else {
        maxSellingPrice = parseFloat(this.product.product.products.max_selling_price);
      }

      if (isNaN(sellingPrice)) sellingPrice = 0.00;

      if (sellingPrice < dtgPrice) {
        this.product.selling_price = dtgPrice.toFixed(2);
        if (sellingPrice != 0.00 && !skipNotification)
          helpers.alert("The selling price of a product cannot be less than the Base cost of 1 product sold");
      } else {
        this.product.selling_price = sellingPrice.toFixed(2);
      }

      // Only check for maximum selling price if it is not a Shopify Campaign
      if (this.isAPIOrder() === false) {
        if (maxSellingPrice !== 0.00 && sellingPrice > maxSellingPrice) {
          helpers.alert("The selling price for this product cannot exceed $" + maxSellingPrice.toFixed(2));
          this.product.selling_price = maxSellingPrice.toFixed(2);
        }
      }
    },
    isDoubleSided: function() {
      return this.$root.designerItems.front.length > 0 && this.$root.designerItems.back.length > 0
    },
    isProfitLoss: function() {
      return parseFloat(this.profit) < 0;
    },
    isDTGLoss: function() {
      return parseFloat(this.dtgProfit) < 0;
    },
    setHoverColor: function(color) {
      this.hoverColor = color.hex;
    },
    resetHoverColor: function() {
      this.hoverColor = undefined;
    },
    setLastColor: function(color) {
      this.lastSelectedColor = color.hex;
    },
    isManualOrder: function() {
      return this.$root.isManualOrder();
    },
    estimatedSalePrice: function(product) {
      return this.$parent.estimatedSalePrice(product);
    },
    isAPIOrder: function() {
      return this.$root.isAPIOrder();
    },
    isProductUSOnly(id) {
      return this.$root.isProductUSOnly(id);
      // console.log(id);
    }
  },
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/details_tab/selectedProductsList.js